import seo from '../data/seo.cjs';

export const applyPageSeo = (pathname) => {
  const pageSeo = seo.getPageSeo(pathname, process.env.REACT_APP_SITE_URL);
  document.title = pageSeo.title;
  const tags = {
    'meta[name="description"]': pageSeo.description,
    'meta[name="robots"]': pageSeo.robots,
    'meta[property="og:title"]': pageSeo.title,
    'meta[property="og:description"]': pageSeo.description,
    'meta[property="og:url"]': pageSeo.url,
    'meta[name="twitter:title"]': pageSeo.title,
    'meta[name="twitter:description"]': pageSeo.description,
    'meta[name="twitter:url"]': pageSeo.url,
  };
  Object.entries(tags).forEach(([selector, content]) => {
    document.querySelector(selector)?.setAttribute('content', content);
  });
  document.querySelector('link[rel="canonical"]')?.setAttribute('href', pageSeo.url);
  const schema = document.getElementById('site-schema');
  if (schema) schema.textContent = JSON.stringify(pageSeo.schema);
};